// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select, selectAll } from 'd3-selection';
import Zion from './utils/Zion';
import { classify } from './utils/helpers';


// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
// import config from './config';
// import graphic from './graphic';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }


  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw() {
  const actions = data.filter(d => d.topic !== 'exclude');

  const keys = [...new Set(actions.map(item => item.topic))];
  const topics = [];
  keys.forEach((k) => {
    topics.push({
      topic: k,
      orders: actions.filter(d => d.topic == k),
    });
  });

  // remove DEI and combine it into Fed gov't
  const deiIndex = topics.findIndex(t => t.topic == 'DEI');
  const dei = topics.splice(deiIndex, 1)[0];
  const fedIndex = topics.findIndex(t => t.topic == 'Gobierno federal');
  topics[fedIndex].orders = [...topics[fedIndex].orders, ...dei.orders];


  // Sort by number of orders, but put 'Other' last
  topics.sort((a, b) => {
    if (a.topic == 'Otro') {
      return 1;
    } if (b.topic == 'Otro') {
      return -1;
    } if (a.orders.length > b.orders.length) {
      return -1;
    } if (a.orders.length < b.orders.length) {
      return 1;
    }
    return 0;
  });


  const container = select('#graphic');
  container.html('');

  // update timestamp
  const timeStamp = select('#timestamp');
  timeStamp.text(meta.timestamp);

  // insert total count into headline
  const orderCount = select('span#order-count');
  orderCount.text(actions.length);


  const topic = container.append('div')
    .attr('class', 'orders')
    .selectAll('.topic')
    .data(topics)
    .enter()
    .append('div')
    .attr('class', 'topic');


  const topicLabel = topic.append('div')
    .attr('class', d => `topic-label ${classify(d.topic)}`)
    .html((d) => {
      if (d.topic != 'Gobierno federal') {
        return `<h2 class="topic-label__name">${d.topic}</h2><p class="topic-count">${d.orders.length} ${d.orders.length == 1 ? 'acción' : 'acciones'}</p>`;
      }
      const deiCount = d.orders.filter(a => a.topic == 'DEI').length;
      return `<h2 class="topic-label__name">${d.topic}</h2><p class="topic-count">${d.orders.length} ${d.orders.length == 1 ? 'acción' : 'acciones'} <br class="no-mobile" /> (incl. ${deiCount} <span class="dei">DEI</span>*)</p>`;
    });

  const topicIcons = topic.append('div')
    .attr('class', 'topic-icons')
    .selectAll('.icon')
    .data(d => d.orders)
    .enter()
    .append('img')
    .attr('src', './document.png')
    .attr('class', d => `icon ${classify(d.topic)}`);
}
